import { render, staticRenderFns } from "./UiChartNoData.vue?vue&type=template&id=075f84de"
import script from "./UiChartNoData.vue?vue&type=script&lang=js"
export * from "./UiChartNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports